import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, Switch, useLocation, useParams, useRouteMatch } from "react-router-dom";
import { Spin, Modal, message, Button, Menu } from "antd";
import axios from "axios";
import moment from "moment";
import AccountInfo from "../../components/AccountInfo/AccountInfo";
import { ReactComponent as DotsIcon } from "../../img/3dots.svg";
import {
  fetchAccountById,
  getAccountsVersions,
  getActualAddressVersions,
  getEmailsVersions,
  getLegalAddressVersions,
  getOrganizationsVersions,
  getPropertiesVersions,
  getSubscribers,
  fetchAccountOrganization,
  fetchAccountStatusById,
  fetchAccountPropertiesByOrgId,
  fetchAccountAddressesByAddIds,
  fetchAccountEmails,
  fetchAccountPhonesVersions,
  fetchAccountPhones,
  fetchIndividualByAccountId,
  fetchIndividualDocument,
  fetchAccountTypePropertyVersions,
  fetchAccountByIdForBlocking,
} from "../../store/slices/accounts";
import { toHttpFormatEndOfDay, toHttpFormatStartOfDay } from "../../lib/utils/formatDate";
import {
  getCreateAccountEmailsRoute,
  getCreateEmailVersionRoute,
  getCreateOrganizationVersionRoute,
  getCreateSubscriberVersionRoute,
  getEditAccountVersionsRoute,
  getEditAddressesVersionsRoute,
  getIndividualDocumentRoute,
  getSubscribersRoute,
} from "../../lib/routes/accounts";
import { checkIsLoading, checkIsLoaded } from "../../lib/utils";
import { fetchGetAgreementsByAccId } from "../../store/slices/agreements";
import HistoryAndPropertyModal from "../../components/HistoryAndPropertyModal/HistoryAndPropertyModal";
import { hasAccess } from "../../components/RolesModule/hasAccess";
import { MENU_ACCOUNT_ACCOUNTINFO_WRITE } from "../../lib/const/permissions";
import { AccountInfoContainerContext } from "./AccountInfoContainerContext";
import {
  getCreateIndividualContactPhoneRoute,
  getCreateOrganizationContactPhoneRoute,
  getIndividualUpdateRoute,
  getIndividualDeleteRoute,
  getUpdateAccountPhoneRoute,
  getAccountPhonesDeleteRoute,
} from "../../lib/routes/accountsTs";
import {
  getCountriesTypes,
  getDocTypes,
  fetchPhoneTypes,
  fetchAccountStatuses,
  fetchCountries,
  fetchAccountTypes,
} from "../../store/slices/dicts";
import { fetchAgrStatus } from "../../store/slices/rtkDictionaries";
import { fetchIndividualVersions, getSubscribersVersions } from "../../store/slices/accountsTs";
import rtkRequestStatusCodes from "../../lib/const/rtkRequestStatusCodes";
import RouteWithSubRoutes from "../../router/RouteWithSubRoutes";
import plusIcon from "../../img/whitePlus.svg";
import { hasLocalAccess } from "../../lib/configs";
import { fetchBlockingTypes } from "../../store/slices/blocking";
import { useAppSelector } from "../..";
import { BlockingObjTypes } from "../../lib/const/blockingObjTypes";
import { getBlockingStatusIcon } from "../../lib/utils/getBlockingStatusIcon";
import BlockingModal from "../../components/BlockingModal/BlockingModal";
import useBlockingMode from "../../lib/hooks/useBlockingMode";
import "./AccountInfoContainer.less";

// TODO ROSTISLAV Refactoring

export default function AccountInfoContainer(props) {
  const dispatch = useDispatch();
  const { account, accountLoading } = useSelector((state) => state.accounts);
  const {
    docTypesLoading,
    countriesTypesLoading,
    phoneTypesLoading,
    accountTypesLoading,
  } = useSelector((state) => state.dicts);

  const { blockingTypesLoading } = useAppSelector((state) => state.blocking);

  const isBlockingMode = useBlockingMode();

  const accountName = account.individual
    ? [account.individual?.lastName, account.individual?.firstName, account.individual?.middleName]
        .filter(Boolean)
        .join(" ")
    : account.organization?.fullName;
  const { accountStatusesLoading, countriesLoading } = useSelector((state) => state.dicts);
  const { tenantPropertiesLoading } = useSelector((state) => state.tenants);
  const { agrStatusLoading } = useSelector((state) => state.rtkDictionaries);
  const { accountId } = useParams();
  // const [reprocessModalVisible, setReprocessModalVisible] = useState(false);
  const { url } = useRouteMatch();
  const { pathname } = useLocation();
  const activeKey = pathname.split("/")[pathname.split("/").length - 1].split("-")[0];

  const [exiteIdFromDate, setExiteIdFromDate] = useState();
  const [objectId, setObjectId] = useState(null);
  const [historyModalVisible, setHistoryModalVisible] = useState(false);
  const [handleCreateSubscriberVersionLoading, setHandleCreateSubscriberVersionLoading] = useState(
    rtkRequestStatusCodes.idle
  );
  const handleHideModal = () => {
    setHistoryModalVisible(false);
    setObjectId(null);
  };

  const getPropertyVersions = async (propertiesArr, propType) => {
    dispatch(getPropertiesVersions({ propertiesArr: [propertiesArr], propType }));
  };

  const fetchEmailVersions = (emailsIds) => {
    dispatch(getEmailsVersions({ emailsIds: [emailsIds] }));
  };

  const fetchAccountSubscribers = () => {
    dispatch(getSubscribers({ accountId }));
  };

  const getAccountEmails = () => {
    dispatch(fetchAccountEmails({ accountId }));
  };

  const getAccount = () => {
    dispatch(fetchAccountById({ id: accountId }));
  };

  const getAccountVersions = () => {
    dispatch(getAccountsVersions({ accountsIds: [accountId] }));
  };

  const getAccountStatus = (accId) => {
    dispatch(fetchAccountStatusById({ id: accId }));
  };

  const getAccountProperties = (orgId) => {
    dispatch(fetchAccountPropertiesByOrgId(orgId));
  };

  const getAccountAddresses = (legalAddressId, actualAddressId) => {
    dispatch(fetchAccountAddressesByAddIds({ legalAddressId, actualAddressId }));
  };

  const getIndividualDocument = () => {
    dispatch(fetchIndividualDocument({ accountId }));
  };

  const updateIndividualDocument = ({ document }) => {
    axios
      .patch(getIndividualDocumentRoute({ documentId: document.id }), document)
      .then(() => {
        message.success("Документ успешно обновлен");
        getIndividualDocument();
      })
      .catch(() => {
        message.error("Ошибка обновления документа");
      });
  };

  const changeOrganizationVersion = async (orgId, fromDate, value, callback, force = false) => {
    await axios
      .patch(getCreateOrganizationVersionRoute(orgId, fromDate, force), value)
      .then(() => {
        if (callback) callback();
        dispatch(fetchAccountOrganization({ orgId: account.organization.id }));
        return force
          ? message.success("Версия успешно обновлена")
          : message.success("Версия успешно обновлена");
      })
      .catch(() => {
        message.error("Ошибка");
      });
  };

  const closeOrganizationVersion = async (orgId, fromDate, callback) => {
    axios
      .delete(getCreateOrganizationVersionRoute(orgId, fromDate))
      .then(() => {
        if (callback) callback();
        dispatch(fetchAccountOrganization({ orgId: account.organization.id }));
        message.success("Дата закрытия успешно изменена");
      })
      .catch(() => {
        message.error("Ошибка");
      });
  };

  const changeAccountVersion = (accountStatusId, fromDate, accTypeId) => {
    axios
      .patch(getEditAccountVersionsRoute(accountId, fromDate), {
        id: accountId,
        accountStatusId,
        accTypeId,
      })
      .then(() => {
        getAccountStatus(accountId);
        getAccountVersions();
        message.success("Версия успешно обновлена");
      })
      .catch(() => {
        message.error("Ошибка");
      });
  };

  const closeAccountVersion = async (accId, fromDate) => {
    axios
      .delete(getEditAccountVersionsRoute(accId, fromDate))
      .then(() => {
        getAccountVersions(accountId);
        message.success("Дата закрытия успешно изменена");
      })
      .catch(() => {
        message.error("Ошибка");
      });
  };

  const fetchSubscriberVersions = (subscribersId) => {
    dispatch(getSubscribersVersions({ subscribersId }));
  };

  const handleCloseSubscriberVersion = (subscriberId, toDate) => {
    axios
      .delete(
        getCreateSubscriberVersionRoute(
          subscriberId,
          encodeURIComponent(toHttpFormatEndOfDay(toDate))
        )
      )
      .then(() => {
        fetchAccountSubscribers();
        fetchSubscriberVersions([subscriberId]);
        message.success("Дата закрытия успешно изменена");
      })
      .catch(() => {
        message.error("Ошибка");
      });
  };

  const handleCreateEmailVersion = ({ fromDate, emailData, force }) => {
    axios
      .patch(
        getCreateEmailVersionRoute(emailData.id, encodeURIComponent(fromDate), force),
        emailData
      )
      .then(() => {
        getAccountEmails();
        fetchEmailVersions([emailData.id]);
        message.success(`Версия успешно ${force ? "обновлена" : "создана"}`);
      })
      .catch(() => {
        message.error("Ошибка создания версии e-mail");
      });
  };

  const handleCloseEmailVersion = (emailId, toDate) => {
    axios
      .delete(
        getCreateEmailVersionRoute(emailId, encodeURIComponent(toHttpFormatStartOfDay(toDate)))
      )
      .then(() => {
        getAccountEmails();
        fetchEmailVersions([emailId]);
        message.success("Дата закрытия успешно изменена");
      })
      .catch(() => {
        message.error("Ошибка изменения даты закрытия e-mail");
      });
  };

  // const checkExiteId = (body) => axios.post(checkProcessingRoute(), body);

  // const handleCheckExiteId = (extId) =>
  //   checkExiteId({
  //     client: {
  //       accountId,
  //       externalId: extId,
  //     },
  //     onDate: moment(),
  //   });

  // const startReprocess = (body) => {
  //   axios.post(reprocessRoute(), body);
  // };

  // const handleStartReprocess = (extId, fromDate) => {
  //   startReprocess({
  //     client: {
  //       accountId,
  //       externalId: extId,
  //     },
  //     fromDate,
  //     onDate: moment(),
  //   });
  // };

  // const checkAndStartReprocess = (record, fromDate) => {
  //   if (moment(fromDate).isBefore(moment())) {
  //     setExiteIdFromDate(fromDate);
  //     // handleStartReprocess(record.externalId, fromDate);
  //     // handleCheckExiteId(record.externalId)
  //     //   .then(() => {
  //     //     handleStartReprocess(record.externalId, fromDate);
  //     //   })
  //     //   .catch((err) => {
  //     //     if (err.response.status === 500) setReprocessModalVisible(true);
  //     //   });
  //   }
  // };

  // const renderReprocessModal = (fromDate) => {
  //   const footer = () => [
  //     <Button type="primary" onClick={() => history.push("/rejected-traffic")}>
  //       OK
  //     </Button>,
  //   ];
  //   return (
  //     <Modal visible={reprocessModalVisible} closable={false} footer={footer()}>
  //       <Row justify="start" wrap={false}>
  //         <Col span={2}>
  //           <WarningIcon />
  //         </Col>
  //         <Col span={22}>
  //           <h3>
  //             {`Перетарификация транзакций с ${
  //               fromDate && toDisplayFormat(fromDate)
  //             } не может быть выполнена.
  //             Необходимо произвести анализ ошибок в форме Биллинг – Трафик`}
  //           </h3>
  //         </Col>
  //       </Row>
  //     </Modal>
  //   );
  // };

  const getIndividualVersions = () =>
    dispatch(fetchIndividualVersions({ individualId: account.individual.id }));

  const getAccountIndividual = () => dispatch(fetchIndividualByAccountId({ accountId }));

  const handleUpdateIndividual = ({ fromDate, data, force }) => {
    const url = getIndividualUpdateRoute({
      individualId: account.individual.id,
      fromDate,
      force,
    });
    axios
      .patch(url, data)
      .then(() => {
        const msg = force ? "Версия успешно обновлена" : "Версия успешно создана";
        message.success(msg);
        getAccountIndividual();
        getIndividualVersions();
        // dispatch(fetchAccountById({ id: accountId }));
      })
      .catch(() => {
        const msg = force ? "Ошибка обновления версии" : "Ошибка создания версии";
        message.error(msg);
      });
  };

  const handleCloseIndividual = (fromDate) => {
    const url = getIndividualDeleteRoute({
      individualId: account.individual.id,
      fromDate: toHttpFormatEndOfDay(fromDate),
    });
    axios
      .delete(url)
      .then(() => {
        message.success("Дата закрытия успешно изменена");
        getAccountIndividual();
        getIndividualVersions();
      })
      .catch(() => {
        message.error("Ошибка");
      });
  };

  const handleCreateSubscriberVersion = async (
    subscriberId,
    fromDate,
    value
    // isNeededRetarification = false
  ) => {
    setHandleCreateSubscriberVersionLoading(rtkRequestStatusCodes.idle);
    axios
      .patch(
        getCreateSubscriberVersionRoute(
          subscriberId,
          encodeURIComponent(toHttpFormatStartOfDay(fromDate))
        ),
        value
      )
      .then(() => {
        setHandleCreateSubscriberVersionLoading(rtkRequestStatusCodes.fulfilled);
        fetchAccountSubscribers();
        fetchSubscriberVersions([subscriberId]);
        message.success("Версия успешно обновлена");
        // if (isNeededRetarification) checkAndStartReprocess(value.externalId, fromDate);
      })
      .catch(() => {
        setHandleCreateSubscriberVersionLoading(rtkRequestStatusCodes.rejected);
        Modal.error({
          content: `Subscriber с externalId = ${value.externalId} уже существует`,
        });
      });
  };

  const fetchAddressVersions = ({ addressId, addressType }) => {
    if (addressType === "legalAddress") {
      dispatch(
        getLegalAddressVersions({
          addressesIds: [addressId],
        })
      );
    } else if (addressType === "actualAddress") {
      dispatch(
        getActualAddressVersions({
          addressesIds: [addressId],
        })
      );
    }
  };

  const changeAddressVersion = ({
    addressId,
    fromDate,
    addressObj,
    addressType,
    force = false,
  }) => {
    axios
      .patch(getEditAddressesVersionsRoute(addressId, fromDate, force), addressObj)
      .then(() => {
        fetchAddressVersions({ addressId, addressType });
        const legalAddressId = account.individual
          ? account.individual.registrationAddress.id
          : account.organization.legalAddress.id;
        const actualAddressId = account.individual
          ? account.individual.actualAddress.id
          : account.organization.actualAddress.id;
        getAccountAddresses(legalAddressId, actualAddressId);
        return force
          ? message.success("Версия успешно обновлена")
          : message.success("Версия успешно обновлена");
      })
      .catch(() => {
        const msg = force ? "Ошибка изменения версии" : "Ошибка добавления версии";
        message.error(msg);
      });
  };

  const closeAddressVersion = (addressId, fromDate, callback) => {
    axios
      .delete(getEditAddressesVersionsRoute(addressId, fromDate))
      .then(() => {
        if (callback) callback();
        getAccountAddresses(
          account.organization.legalAddress.id,
          account.organization.actualAddress.id
        );
        return message.success("Дата закрытия успешно изменена");
      })
      .catch(() => {
        message.error("Ошибка");
      });
  };

  const createExiteId = (value, callback) => {
    return axios
      .post(getSubscribersRoute(), value)
      .then(() => {
        message.success("Технический ID успешно создан");
        fetchAccountSubscribers();
        if (callback && typeof callback === "function") {
          callback();
        }
      })
      .catch(() => {
        Modal.error({
          content: `Subscriber с externalId = ${value.externalId} уже существует`,
        });
      });
  };

  const createEmail = (value) => {
    axios
      .post(getCreateAccountEmailsRoute(accountId, toHttpFormatStartOfDay(Date())), value)
      .then(() => {
        message.success("Электронная почта успешно создана");
        getAccountEmails();
      })
      .catch((e) => {
        Modal.error({
          content: e.response.data.message,
        });
      });
  };

  const getAccountOrganizationVersions = (accountOrgId) => {
    dispatch(
      getOrganizationsVersions({
        organizationsIds: [accountOrgId],
      })
    );
  };

  useEffect(() => {
    if (!checkIsLoaded(docTypesLoading)) dispatch(getDocTypes());
    if (!checkIsLoaded(countriesTypesLoading)) dispatch(getCountriesTypes());
    if (!checkIsLoaded(phoneTypesLoading)) dispatch(fetchPhoneTypes());
    if (!checkIsLoaded(countriesLoading)) dispatch(fetchCountries());
    if (isBlockingMode && !checkIsLoaded(blockingTypesLoading)) dispatch(fetchBlockingTypes());
    if (!checkIsLoaded(accountTypesLoading)) dispatch(fetchAccountTypes());
  }, []);

  useEffect(() => {
    if (checkIsLoaded(accountLoading)) {
      dispatch(fetchGetAgreementsByAccId({ accId: accountId }));
    }
  }, [accountLoading]);

  useEffect(() => {
    if (!checkIsLoaded(agrStatusLoading)) dispatch(fetchAgrStatus());
    if (!checkIsLoaded(accountStatusesLoading)) dispatch(fetchAccountStatuses());
  }, []);

  const showHistoryModal = (rec) => {
    setHistoryModalVisible(true);
    setObjectId(rec.id);
  };

  const getAccountPhones = () => dispatch(fetchAccountPhones({ accountId }));

  const createIndividualPhone = ({ phone }) => {
    const url = getCreateIndividualContactPhoneRoute(account.individual.id);
    return axios
      .post(url, phone)
      .then(() => {
        message.success("Контактный телефон успешно создан");
        getAccountPhones();
      })
      .catch(() => {
        message.error("Ошибка создания контактного телефона");
      });
  };

  const createOrganizationPhone = ({ phone }) => {
    const url = getCreateOrganizationContactPhoneRoute(account.organization.id);
    return axios
      .post(url, phone)
      .then(() => {
        message.success("Контактный телефон успешно создан");
        getAccountPhones();
      })
      .catch(() => {
        message.error("Ошибка создания контактного телефона");
      });
  };

  const getAccountTypePropertyVersions = (id) => {
    dispatch(fetchAccountTypePropertyVersions(id));
  };

  const getAccountPhonesVersions = (phoneId) => dispatch(fetchAccountPhonesVersions(phoneId));

  const updateAccountPhone = ({ phoneId, fromDate, force, phone }) => {
    const url = getUpdateAccountPhoneRoute({ phoneId, fromDate, force });
    return axios
      .patch(url, phone)
      .then(({ data }) => {
        getAccountPhones();
        getAccountPhonesVersions(phone.id);
        const msg = force
          ? "Контактный телефон успешно обновлен"
          : "Версия контактного телефона успешно создана";
        message.success(msg);
        return data;
      })
      .catch(() => {
        const errMsg = force
          ? "Ошибка обновления контактного телефона"
          : "Ошибка создания версии контактного телефона";
        message.error(errMsg);
      });
  };

  const closeAccountPhone = ({ phoneId, fromDate }) =>
    axios
      .delete(
        getAccountPhonesDeleteRoute({
          fromDate: toHttpFormatEndOfDay(fromDate),
          phoneId,
        })
      )
      .then(({ data }) => {
        getAccountPhones();
        getAccountPhonesVersions(phoneId);
        message.success("Дата закрытия контактного телефона успешно изменена");
        return data;
      })
      .catch(() => {
        message.error("Ошибка изменения даты закрытия контактного телефона");
      });

  const commonContextValues = {
    accountId,
    getAccountPhonesVersions,
    updateAccountPhone,
    closeAccountPhone,
    fetchEmailVersions,
    createEmail,
    fetchSubscriberVersions,
    handleCreateSubscriberVersion,
    handleCloseSubscriberVersion,
    handleCreateEmailVersion,
    handleCloseEmailVersion,
    changeAccountVersion,
    getAccountVersions,
    fetchAddressVersions,
    changeAddressVersion,
  };

  const organizationContextValues = {
    createOrganizationPhone,
    getAccountTypePropertyVersions,
  };

  const individualContextValues = {
    createIndividualPhone,
    getIndividualVersions,
    handleUpdateIndividual,
    handleCloseIndividual,
    updateIndividualDocument,
  };

  const renderTimeZine = () => {
    const findPropertyTimeZone =
      account && account?.properties?.find((item) => item?.typeId === "timezone");
    if (!findPropertyTimeZone) {
      return null;
    }
    return (
      <div style={{ fontSize: "14px", color: "#000000" }}>
        <span style={{ color: "#334455" }}>Часовой пояс: </span>{" "}
        <span>{`GMT ${findPropertyTimeZone.stringValue}`}</span>
      </div>
    );
  };

  const [objectBlockingId, setObjectBlockingId] = useState({});

  const handleShowBlockingModal = (objId) => {
    setObjectBlockingId(objId);
  };

  const handleHideBlockingModal = () => {
    setObjectBlockingId({});
  };

  return (
    <Spin
      spinning={checkIsLoading(
        accountLoading,
        accountStatusesLoading,
        docTypesLoading,
        countriesTypesLoading,
        phoneTypesLoading,
        tenantPropertiesLoading,
        accountTypesLoading
      )}
    >
      <AccountInfoContainerContext.Provider
        value={{ ...commonContextValues, ...organizationContextValues, ...individualContextValues }}
      >
        <>
          <div style={{ alignItems: "center", display: "flex", justifyContent: "space-between" }}>
            <div style={{ display: "flex", alignItems: "center" }}>
              <h1 style={{ margin: 0, marginRight: 10 }}>Аккаунт</h1>
              <Button
                onClick={(e) => {
                  e.stopPropagation();
                  showHistoryModal({ id: accountId });
                }}
                className="iconButton"
                style={{ outline: "none", marginLeft: "-10px" }}
                type="text"
                htmlType="button"
                icon={<DotsIcon />}
              />
              {isBlockingMode && account?.blockingStatus !== null && (
                <div style={{ marginRight: 5 }}>
                  {getBlockingStatusIcon(account?.blockingStatus, () =>
                    handleShowBlockingModal({ id: accountId })
                  )}
                </div>
              )}
            </div>
            {renderTimeZine()}
          </div>

          <div className="account-menu-container">
            {hasLocalAccess("account.contactList") && (
              <div className="account-info-menu">
                <Menu mode="horizontal" selectedKeys={[activeKey]}>
                  <Menu.Item className="account-info-menu__item" key="info">
                    <Link className="account-info-menu__link" to={`/accounts/${accountId}/info`}>
                      Аккаунт
                    </Link>
                  </Menu.Item>

                  <Menu.Item className="account-info-menu__item ml15" key="contacts">
                    <Link
                      className="account-info-menu__link"
                      to={`/accounts/${accountId}/info/contacts`}
                    >
                      Контактные лица
                    </Link>
                  </Menu.Item>
                </Menu>
              </div>
            )}
            {url.includes("contacts") && (
              <Button
                type="primary"
                className="addTariffBtn"
                icon={<img src={plusIcon} width="8px" alt="plus" />}
              >
                &nbsp;&nbsp;Добавить
              </Button>
            )}
          </div>

          <Switch>
            {props.routes.map((route) => {
              if (route.component === AccountInfo) {
                return (
                  <RouteWithSubRoutes
                    key={route.path}
                    {...route}
                    routeProps={{
                      getAccount,
                      fetchAccountSubscribers,
                      fetchSubscriberVersions,
                      handleCreateSubscriberVersion,
                      handleCreateSubscriberVersionLoading,
                      handleCloseSubscriberVersion,
                      fetchEmailVersions,
                      handleCreateEmailVersion,
                      handleCloseEmailVersion,
                      changeOrganizationVersion,
                      closeOrganizationVersion,
                      closeAccountVersion,
                      changeAccountVersion,
                      changeAddressVersion,
                      closeAddressVersion,
                      getPropertyVersions,
                      createExiteId,
                      createEmail,
                      getAccountOrganizationVersions,
                      getAccountVersions,
                      fetchAddressVersions,
                      // checkExiteId,
                      // startReprocess,
                      // checkAndStartReprocess,
                    }}
                  />
                );
              }
              return <RouteWithSubRoutes key={route.path} {...route} />;
            })}
          </Switch>
        </>
      </AccountInfoContainerContext.Provider>
      <HistoryAndPropertyModal
        objectTypeSysname="account"
        objectId={objectId}
        handleHideModal={handleHideModal}
        visibleModal={historyModalVisible}
        hasAccessToEdit={hasAccess(MENU_ACCOUNT_ACCOUNTINFO_WRITE)}
      />
      <BlockingModal
        objectTypeId={BlockingObjTypes.Аккаунт}
        objectId={accountId}
        handleHideModal={handleHideBlockingModal}
        visibleModal={objectBlockingId?.id}
        accountName={accountName}
        onSuccessRequest={() => dispatch(fetchAccountByIdForBlocking({ id: accountId }))}
      />
    </Spin>
  );
}
